// ASN Channel Logo URLs
export const CHANNEL_LOGOS = {
  "channel1": "https://customer-assets.emergentagent.com/job_fa16d17c-a8c4-4ad7-aea4-8c13d1e1cc20/artifacts/fof8m6tw_ASN1%20LRG.png",
  "channel2": "https://customer-assets.emergentagent.com/job_fa16d17c-a8c4-4ad7-aea4-8c13d1e1cc20/artifacts/pzsdy5x0_ASN2%20LRG.png",
  "channel3": "https://customer-assets.emergentagent.com/job_fa16d17c-a8c4-4ad7-aea4-8c13d1e1cc20/artifacts/235wrmd8_ASN3%20Logo.png",
  "channel4": "https://customer-assets.emergentagent.com/job_fa16d17c-a8c4-4ad7-aea4-8c13d1e1cc20/artifacts/28m0qna2_TheTeamTV%20White%20Logo.png", // The Team TV
};

export const ASN_TV_LOGO = "https://customer-assets.emergentagent.com/job_fa16d17c-a8c4-4ad7-aea4-8c13d1e1cc20/artifacts/7kbgi8rs_ASN%20TV%20Logo%20White.png";

// Helper function to get channel logo
export const getChannelLogo = (channelId) => {
  return CHANNEL_LOGOS[channelId] || CHANNEL_LOGOS.channel1;
};
